// original: https://images.pexels.com/photos/2833037/pexels-photo-2833037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260
export const DefaultBannerImage =
  'v1717597416/default-event-landing-banner_gwkpsg.jpg';
export const DefaultBannerImageLow =
  `https://res.cloudinary.com/revnt/image/upload/q_auto:low,cs_srgb,dpr_2.0,h_750,w_1260/${DefaultBannerImage}`;
